import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-back',
  templateUrl: './button-back.component.html',
  styleUrls: ['./button-back.component.less']
})
export class ButtonBackComponent implements OnInit {
  @Output() onClick = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  btn_click( ) {
    this.onClick.emit();
  }

}
